/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Transcript_ImportInputs */

const en_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Transcript Import`)
};

const fr_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de transcription IA`)
};

const de_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Transkriptimport`)
};

const it_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione di trascrizioni AI`)
};

const ru_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт расшифровки ИИ`)
};

const es_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de transcripciones mediante IA`)
};

const zh_cn2_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI转录导入`)
};

const ja_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIトランスクリプトインポート`)
};

const hi_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई ट्रांसक्रिप्ट आयात`)
};

const pt_pt2_ai_transcript_import = /** @type {(inputs: Ai_Transcript_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de transcrição por IA`)
};

/**
* | output |
* | --- |
* | "AI Transcript Import" |
*
* @param {Ai_Transcript_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_transcript_import = /** @type {((inputs?: Ai_Transcript_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Transcript_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ai_transcript_import(inputs)
	if (locale === "de") return de_ai_transcript_import(inputs)
	if (locale === "it") return it_ai_transcript_import(inputs)
	if (locale === "ru") return ru_ai_transcript_import(inputs)
	if (locale === "es") return es_ai_transcript_import(inputs)
	if (locale === "zh-CN") return zh_cn2_ai_transcript_import(inputs)
	if (locale === "ja") return ja_ai_transcript_import(inputs)
	if (locale === "hi") return hi_ai_transcript_import(inputs)
	if (locale === "pt-PT") return pt_pt2_ai_transcript_import(inputs)
	return en_ai_transcript_import(inputs)
});